export default "__VITE_ASSET__Dd6GY995__"